/**
 * Recipe Feedback Endpoints - Centralized API URLs
 */

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const RECIPE_FEEDBACK_ENDPOINTS = {
  BASE: `${API_URL}/recipe-feedback`,
  RECORD: `${API_URL}/recipe-feedback`,
} as const;

export default RECIPE_FEEDBACK_ENDPOINTS;
